import { render, staticRenderFns } from "./main-navbar-forget-password.vue?vue&type=template&id=44db6af9"
import script from "./main-navbar-forget-password.vue?vue&type=script&lang=js"
export * from "./main-navbar-forget-password.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports